"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableColumnsMock = void 0;
exports.tableColumnsMock = [
    { label: '', key: 'archived', style: { flex: 0.1 } },
    { label: 'Partner name', key: 'partnerName', sort: 'ASC' },
    { label: 'Description', key: 'description', style: { flex: 4 } },
    { label: 'Exchanges', key: 'exchanges', style: { flex: 2 } },
    { label: 'Date', key: 'date', sort: 'INACTIVE' },
    { label: 'Message type', key: 'messageType', sort: 'INACTIVE', style: { flex: 2 } },
    { label: '', key: 'status', style: { flex: 0.2 } }
];
//# sourceMappingURL=table-column.js.map